<script setup>
import MainHeader from "@/Layouts/MainHeader.vue";
import Header from "@/Layouts/Header.vue";
import FrontSecondBanner from "@/Layouts/FrontSecondBanner.vue";
import PracticeArticles from "@/Layouts/PracticeArticles.vue";
import FrontBanner from "@/Layouts/FrontBanner.vue";
import Pile from "@/Layouts/Pile.vue";
import ReviewsCarousel from "@/Layouts/ReviewsCarousel.vue";
import YandexMapBlock from "@/Layouts/YandexMapBlock.vue";
import Slider from "@/Layouts/Slider.vue";
import Youtube from "@/Layouts/Youtube.vue";
import SliderUslug from "@/Layouts/SliderUslug.vue";
import FeedCarousels from "@/Layouts/FeedCarousels.vue";
import RatingReady from "@/Components/RatingReady.vue";
import Address from "@/Layouts/Address.vue";
//import VK from "@/Layouts/Vk.vue";
import MainFooter from "@/Layouts/MainFooter.vue";
import Tracking from "@/Components/ResourseLoader.vue";
import PopupDialogue from "@/Layouts/PopupDialogue/PopupDialogue.vue";
import Bundle from "@/Components/Bundle.vue";
import FlashMessage from "@/Components/FlashMessage.vue";
import { Head } from "@inertiajs/vue3";
import Chat from "@/Layouts/Chat.vue";

import { ref } from "vue";

const showAnimation = ref(true);

defineProps({
  city: Object,
  flash: Object,
  mainoffers: Object,
  secondoffers: Object,
  practice: Array,
  reviews: Object,
  reviewscount: Number,
  rating: Number,
  users: Object,
  auth: Object,
  bundles: Object,
  user: Object,
  usluga: Object,
  usluga_from_url: Object,
  lawyers: Object,
  backendurl: String,
  carousel_articles: Array,
  carousel_questions: Array,
});

let secondbannerpc =
  "https://nedicom.ru/storage/images/services/mainpcjuly.webp";

let mainbannerimgmobile =
  'url("https://nedicom.ru/storage/images/services/mainpcjuly.webp")';
let mainbannerpc = "https://nedicom.ru/storage/images/services/mainpcjuly.webp";
</script>

<template>
  <FlashMessage :message="flash.message" />

  <Head>
    <title>Консультация юристов от Мина и партнеры | юристы, которым не всё равно.</title>
    <meta
      name="description"
      content="Консультация юриста в реальных офисах по всей России. Юридическая помощь гражданам и бизнесу — сначала оцениваем перспективы, потом предлагаем решение. Мина и партнеры — юристы, которым не всё равно."
    />
    <meta
      property="og:title"
      content="Консультация юристов от Мина и партнеры | юристы, которым не всё равно."
    />
    <meta
      property="og:description"
      content="Консультация юриста в реальных офисах по всей России. Юридическая помощь гражданам и бизнесу — сначала оцениваем перспективы, потом предлагаем решение. Мина и партнеры — юристы, которым не всё равно."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nedicom.ru" />
    <meta property="og:image" :content="secondbannerpc" />
    <meta property="og:site_name" content="nedicom.ru" />
    <meta property="og:locale" content="ru_RU" />
    <link rel="canonical" href="https://nedicom.ru" />
  </Head>

  <div
    class="min-h-screen"
    style="zoom: 0.82"
    itemscope
    itemtype="https://schema.org/LegalService"
  >
    <MainHeader :auth="auth" :city="city" :showPhone="true" />
    <!-- Ориентир main: без него программа чтения с экрана не умеет перепрыгнуть шапку к содержимому. Классы повторяют flex-контекст корня, чтобы дети остались flex-элементами. -->
    <main class="flex flex-col flex-1">

    <FrontSecondBanner
      :key="backendurl"
      :tracking="$page.props.tracking"
      :backendurl="backendurl"
      :city="city"
      :usluga_from_url="usluga_from_url"
      :lawyers="lawyers"
      :mainoffers="mainoffers"
      :secondoffers="secondoffers"
    />

    <!-- Цитата юриста — SEO H1 -->
    <section class="bg-gray-50 border-y border-gray-200 py-12">
      <div class="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row sm:items-center gap-10">

        <!-- Левая часть: H1 -->
        <div class="flex-1">
          <h1 class="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-snug tracking-tight">
            Консультация юриста<br>
            <span class="text-blue-600">с оценкой перспектив</span>
          </h1>
        </div>

        <!-- Разделитель -->
        <div class="hidden sm:block w-px self-stretch bg-gray-200"></div>

        <!-- Правая часть: цитата + аватар -->
        <div class="flex-1 flex items-center gap-4">
          <img
            src="https://nedicom.ru/storage/usr/1/avatar/avatar_1779287971.webp"
            alt="Марк Мина"
            class="w-16 h-16 rounded-full object-cover ring-2 ring-blue-100 shadow shrink-0"
          />
          <div>
            <p class="text-base text-gray-700 italic leading-relaxed">
              «В любом деле главное правильный путь.»
            </p>
            <p class="mt-2 text-sm font-semibold text-gray-500 tracking-wide">— Марк Мина, управляющий партнёр</p>
          </div>
        </div>

      </div>
    </section>

    <YandexMapBlock :city="city" />

    <ReviewsCarousel :reviews="reviews" />

    <FeedCarousels :articles="carousel_articles" :questions="carousel_questions" :auth="auth" />

    <!--
    <Chat :user="user" :usluga="usluga" />
    -->

    </main>
    <MainFooter />

    <Tracking
      :key="backendurl"
      :tracking="$page.props.tracking"
      :backendurl="backendurl"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "Breakpoints",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    // carousel settings
    settings: {
      itemsToShow: 1.25,
      snapAlign: "center",
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3.5,
        snapAlign: "center",
      },
      // 1024 and up
      1024: {
        itemsToShow: 3.5,
        snapAlign: "start",
      },
    },
  }),
});
</script>